import { gql } from 'graphql-request';
import { useCustomerIdToken } from '@hooks/customer/useCustomer';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import useSWRImmutable from 'swr/immutable';
import {
  GraphQLRequestWithTokenProps,
  requestWithTokenRequired,
} from '@repo/ui/src/utils/graphql-request';

interface Props {
  slotId: string;
}

interface RecipeResponse {
  savedByUser: boolean;
}

export const getRecipeBySlotIdQuery = gql`
  query GetRecipeBySlotId($slotId: String!) {
    getRecipeBySlotId(slotId: $slotId) {
      savedByUser
    }
  }
`;

const fetcher = async ({
  document,
  variables,
  idToken,
  locale,
}: GraphQLRequestWithTokenProps<{ slotId: string }>) => {
  const data = await requestWithTokenRequired({
    document,
    variables,
    idToken,
    locale,
  });

  return data?.getRecipeBySlotId ?? null;
};

export const useSavedRecipe = ({ slotId }: Props) => {
  const { locale } = useCurrentUrl();
  const idToken = useCustomerIdToken();

  const { data, isLoading, mutate } = useSWRImmutable<RecipeResponse | null>(
    slotId ? { document: getRecipeBySlotIdQuery, variables: { slotId }, idToken, locale } : null,
    fetcher,
    {},
  );

  return {
    isSaved: data?.savedByUser ?? false,
    isLoading,
    mutate,
  };
};
